import Top from './top';
import Bottom from './bottom';
const Tooltips = { Top, Bottom };

export default Tooltips;
